<p class="text-zinc-400">
  {{ 'pages.auth.code.noCode' | transloco }}
  @if (resendIn() > 0) {
    <span class="font-medium text-zinc-500">
      {{ 'pages.auth.code.resendIn' | transloco: { seconds: resendIn() } }}
    </span>
  } @else {
    <button
      type="button"
      class="font-medium text-zinc-50 underline underline-offset-2 hover:text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-50"
      [disabled]="busy()"
      (click)="resend.emit()">
      {{ 'pages.auth.code.resend' | transloco }}
    </button>
  }
</p>
@if (changeable()) {
  <p class="text-zinc-400">
    {{ 'pages.auth.code.wrongEmail' | transloco }}
    <button
      type="button"
      class="text-zinc-300 hover:text-zinc-50 hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-50"
      (click)="changeEmail.emit()">
      {{ 'pages.auth.code.changeEmail' | transloco }}
    </button>
  </p>
}
